import { render } from "./EventYearHit.vue?vue&type=template&id=7ecbf8d6"
import script from "./EventYearHit.vue?vue&type=script&lang=js"
export * from "./EventYearHit.vue?vue&type=script&lang=js"

import exportComponent from "/app/front-end/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__